import { FormulaParser } from '@datapolarna/formulaparser';
import { createLanguage, type FormulaLanguageDescription } from './formulaLanguage';

export const formulaParser = new FormulaParser();
formulaParser.addDefaultFunctions();

const languageDescription: FormulaLanguageDescription = {
  variables: [
    {
      name: 'index',
      details: 'Number',
      info: 'Index of the storage place',
    },
    {
      name: 'disabled',
      details: 'Boolean',
      info: 'Whether the storage place is disabled',
    },
    {
      name: 'occupied',
      details: 'Boolean',
      info: 'Whether the storage place is occupied by at least one package',
    },
    {
      name: 'packageCount',
      details: 'Number',
      info: 'Number of packages placed on the storage place',
    },
    {
      name: 'maxStackCount',
      details: 'Number',
      info: 'Maximum stack count of the storage place',
    },
    {
      name: 'maxWeight',
      details: 'Number',
      info: 'Maximum weight of the storage place',
    },
    {
      name: 'maxHeight',
      details: 'Number',
      info: 'Maximum height of the storage place in millimeters',
    },
    {
      name: 'x',
      details: 'Number',
      info: 'X position of the storage place in millimeters',
    },
    {
      name: 'y',
      details: 'Number',
      info: 'Y position of the storage place in millimeters',
    },
    {
      name: 'length',
      details: 'Number',
      info: 'Length of the storage place in millimeters',
    },
    {
      name: 'width',
      details: 'Number',
      info: 'Width of the storage place in millimeters',
    },
    {
      name: 'zIndex',
      details: 'Number',
      info: 'Stacking level of the storage place',
    },
    {
      name: 'accessDirections',
      details: 'Number',
      info: 'Bit flags of the sides packages may be picked up from (front=1, right=2, back=4, left=8)',
    },
    {
      name: 'accessFront',
      details: 'Boolean',
      info: 'Whether packages may be picked up from the front side',
    },
    {
      name: 'accessRight',
      details: 'Boolean',
      info: 'Whether packages may be picked up from the right side',
    },
    {
      name: 'accessBack',
      details: 'Boolean',
      info: 'Whether packages may be picked up from the back side',
    },
    {
      name: 'accessLeft',
      details: 'Boolean',
      info: 'Whether packages may be picked up from the left side',
    },
    {
      name: 'storageArea',
      children: [
        {
          name: 'id',
          details: 'Number',
          info: 'Id of storagearea',
        },
        {
          name: 'name',
          details: 'String',
          info: 'Name of storagearea',
        },
        {
          name: 'empty',
          details: 'Boolean',
          info: 'Whether the storagearea is empty',
        },
      ],
    },
    {
      name: 'column',
      details: 'Number',
      info: 'Column of the storage place in its grid (1-based), or null if not set',
    },
    {
      name: 'row',
      details: 'Number',
      info: 'Row of the storage place in its grid (1-based), or null if not set',
    },
  ],
};

export const language = createLanguage(formulaParser, languageDescription);
